module.exports = __webpack_public_path__ + "img/Putra.0d62b404.jpg";